// extracted by mini-css-extract-plugin
export default {"actionsContent":"RangeItem_actionsContent__K3a2A","name":"RangeItem_name__GW5ie","nameWrapper":"RangeItem_nameWrapper__JM3GP","infoWrapper":"RangeItem_infoWrapper__lgeHl"};